import { useEffect } from 'react';

import { Rollout } from '@/common/constants/rollouts';
import { useDriveTreeStore } from '@/drive/stores/DriveTreeStore';
import { useUserStore } from '@/user/stores/UserStore';

function usePreloadDriveTree() {
  const { tree, refresh } = useDriveTreeStore();
  const { user } = useUserStore();

  useEffect(() => {
    if (user?.hasRollout(Rollout.Drive) && !tree) {
      refresh();
    }
  }, [tree, refresh, user]);
}

export default usePreloadDriveTree;
